import UserLocation from '@/types/user/userLocation'
import { BaseService } from './../../base'
export class UserLocationService extends BaseService<UserLocation>() {
    static get entity (): string {
        return 'user_location'
    }
    static get responseName (): string {
        return 'user_location'
    }
}